import React, { useState } from "react";
import Navbar from "../components/Navbar";
import { motion, AnimatePresence } from "framer-motion";
import Image1 from "../assets/indoor/hlc-industrial-lighting.webp";
import Image2 from "../assets/indoor/hlc-commercial-indoor-lighting.webp";
import Image3 from "../assets/indoor/hlc-residential-indoor-lighting.webp";

const newsData = [
  {
    id: 1,
    title: "HLC Launches New Smart Lighting Series",
    date: "October 15, 2025",
    image:
      Image1,
    description:
      "HLC proudly announces its latest smart lighting series featuring energy-efficient and app-controlled lighting systems to redefine modern living.",
    fullText:
      "HLC proudly unveils its new smart lighting series, combining modern design with cutting-edge energy efficiency. The new range includes smart bulbs, ceiling lights, and outdoor systems that integrate seamlessly with mobile and voice assistants. Designed to offer both beauty and function, this series represents HLC’s ongoing commitment to sustainability and innovation in smart living.",
  },
  {
    id: 2,
    title: "HLC Wins National Innovation Award 2025",
    date: "September 28, 2025",
    image:
      Image2,
    description:
      "Our dedication to innovation and sustainability has earned HLC the prestigious National Innovation Award, recognizing excellence in smart lighting solutions.",
    fullText:
      "The National Innovation Award 2025 celebrates HLC’s contributions to the lighting industry through consistent innovation, customer focus, and sustainability. Our advanced R&D team developed adaptive lighting controls that reduce energy consumption by 30%, helping both residential and commercial sectors achieve greener operations.",
  },
  {
    id: 3,
    title: "Upcoming Dealer Meet 2025 in Karachi",
    date: "August 10, 2025",
    image:
      Image3,
    description:
      "Join us at our exclusive annual dealer meet in Karachi where we unveil our future lighting strategies, partnerships, and growth initiatives.",
    fullText:
      "HLC invites all its valued partners to the upcoming Dealer Meet 2025 in Karachi. The event will showcase upcoming product lines, offer insights into the future of smart lighting, and recognize outstanding dealer performance. Networking sessions and live demos will give participants an immersive HLC experience.",
  },
];

const NewsEvents = () => {
  const [selectedNews, setSelectedNews] = useState(null);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100">
      <Navbar />

      {/* Header Section */}
      <div className="text-center py-20 px-4">
   <motion.h1
  className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-[#542757] to-[#9b1f6c] mt-6"
  initial={{ opacity: 0, y: -30 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.8 }}
>
  News & Events
</motion.h1>
        <motion.p
          className="text-gray-600 mt-4 max-w-2xl mx-auto text-base md:text-lg"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.8 }}
        >
          Stay up to date with the latest news, achievements, and events from
          HLC. We are continuously innovating and engaging with our partners and
          community.
        </motion.p>
      </div>

      {/* News Cards */}
      <div className="max-w-6xl mx-auto px-4 pb-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {newsData.map((item) => (
          <motion.div
            key={item.id}
            className="bg-white shadow-lg rounded-2xl overflow-hidden hover:shadow-2xl transition duration-300"
            whileHover={{ scale: 1.03 }}
          >
            <img
              src={item.image}
              alt={item.title}
              className="w-full h-52 object-cover"
            />
            <div className="p-6">
              <h2 className="text-xl font-semibold text-gray-800 mb-2">
                {item.title}
              </h2>
              <p className="text-sm text-gray-500 mb-3">{item.date}</p>
              <p className="text-gray-600 text-sm mb-4">{item.description}</p>
              <button
                onClick={() => setSelectedNews(item)}
                className="text-sm font-semibold text-purple-700 hover:text-pink-500 transition"
              >
                Read More →
              </button>
            </div>
          </motion.div>
        ))}
      </div>

      {/* Modal */}
      <AnimatePresence>
        {selectedNews && (
          <motion.div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              className="bg-white rounded-2xl shadow-2xl max-w-lg w-full relative overflow-hidden"
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ duration: 0.3 }}
            >
              <img
                src={selectedNews.image}
                alt={selectedNews.title}
                className="w-full h-56 object-cover"
              />
              <div className="p-6">
                <h2 className="text-2xl font-bold text-gray-800 mb-2">
                  {selectedNews.title}
                </h2>
                <p className="text-sm text-gray-500 mb-4">
                  {selectedNews.date}
                </p>
                <p className="text-gray-700 leading-relaxed mb-6">
                  {selectedNews.fullText}
                </p>
             <button
  onClick={() => setSelectedNews(null)}
  className="px-5 py-2 rounded-lg bg-gradient-to-r from-[#542757] to-[#9b1f6c] text-white font-semibold hover:opacity-90 transition"
>
  Close
</button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default NewsEvents;
